import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkBaseOption, jkRestReturn } from 'jk-service';
import { MaterialModule, } from "jk-service";
import { SysseService, templateUrlConfigSys } from '../_service_sys';
import { Sysse } from '../_entity_sys';
import { JkDialogEditComponent } from 'jk-service';
import { JackBaseComponentModule } from "jk-service";
import { DispatcherParamComponent } from '../dispatcher-param/dispatcher-param.component';


@Component({
  selector: 'app-sysse-edit',
  templateUrl: templateUrlConfigSys.sysse,
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, MaterialModule, DispatcherParamComponent],
})

export class SysseEditComponent extends JkDialogEditComponent<SysseService, Sysse> {
  override srv!: SysseService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<SysseEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef, data);
  }


}
